import axios from 'axios';
import { baseURL } from './api';

const apiVersion = 'v2';
export const path = process.env.REACT_APP_BASE_URL + '/api/';

class permissionGroupService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || permissionGroupService.resourcePath || permissionGroupService.baseURL;
  };

    // GET /api/v2/users/
    async getAllPermissionGroups(
    ) {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(
        `${this.getBaseURL()}${apiVersion}/permissionGroups/all`,
        { headers },
      );
      return data;
    }

    // PUT //api/users/:id
    async updatePermissionGroups(body) {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.put(`${this.getBaseURL()}${apiVersion}/permissionGroups/update`,
       body, {
        headers,
      });
      return data;
    }

  async getUserPermissionGroup() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/permissionGroups`,
      { headers },
    );
    return data;
  }
  
}


export default permissionGroupService;
